import React from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { useLoadStripe } from "../infra/useLoadStripe";
const elementsOptions = {
  fonts: [{
    family: 'Lufga-Regular',
    src: 'url(https://storage.googleapis.com/anchor-cdn/fonts/Lufga-Regular.woff2)'
  }]
};
export default function StripeElementsProvider(props) {
  const stripeObject = useLoadStripe();
  return /*#__PURE__*/React.createElement(Elements, {
    stripe: stripeObject,
    options: elementsOptions
  }, props.children);
}